/**
 * LogoWordmark — the official Faith 1st Consulting logo (supplied asset).
 * Stacked lockup: "Faith 1st" above the rule, "CONSULTING" below.
 * tone: "ink" (deep blue on light surfaces) | "light" (Witness White on dark).
 * Intrinsic ratio 2.263 : 1 — set `height`, width follows.
 */
export function LogoWordmark({ tone = "ink", height = 64, className = "" }) {
  const src = tone === "light" ? "/brand/faith1st-wordmark-light.png" : "/brand/faith1st-wordmark.png";
  return (
    <img
      src={src}
      alt="Faith 1st Consulting"
      data-testid="f1c-wordmark"
      className={`block select-none ${className}`}
      style={{ height, width: "auto" }}
      draggable={false}
    />
  );
}
